import { useParams, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import { toast } from "react-toastify";
import L from "leaflet";

// ✅ Icône personnalisée (fix marker par défaut Leaflet sur React)
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

// ✅ Coordonnées connues
const zoneCoords: Record<string, [number, number]> = {
  "Zone A": [14.6928, -17.4467],
  "Zone B": [14.7167, -17.4677],
  "Zone C": [14.7400, -17.4300],
  // 🔁 Ajoute ici d'autres zones si nécessaire
};

const CarteZonePage = () => {
  const { zone } = useParams<{ zone: string }>();
  const navigate = useNavigate();

  const coords = zone && zoneCoords[zone] ? zoneCoords[zone] : null;

  useEffect(() => {
    if (!coords) {
      toast.error("📍 Zone inconnue ou non géolocalisée");
      navigate("/admin/terrain/carte");
    }
  }, [coords, navigate]);

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-semibold text-indigo-700 mb-4">
        🗺 Carte complète de la zone : <span className="uppercase">{zone}</span>
      </h1>

      {coords && (
        <MapContainer center={coords} zoom={15} scrollWheelZoom style={{ height: "550px", width: "100%" }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
          />
          <Marker position={coords}>
            <Popup>
              <strong>Zone : </strong>{zone}
            </Popup>
          </Marker>
        </MapContainer>
      )}
    </div>
  );
};

export default CarteZonePage;